export const BASE_URL = 'https://naz.futures.api.naz.io';
